/* (ignored) */


//////////////////
// WEBPACK FOOTER
// min-document (ignored)
// module id = 1387
// module chunks = 5